import { render, staticRenderFns } from "./ReviewResult.vue?vue&type=template&id=7bfead77&scoped=true&"
import script from "./ReviewResult.vue?vue&type=script&lang=js&"
export * from "./ReviewResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfead77",
  null
  
)

export default component.exports